'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAPTION_EDITOR_KEY = exports.CAPTION_EDITOR_KEY = 'CAPTION';


//////////////////
// WEBPACK FOOTER
// ./src/client/components/caption/captionConstants.js
// module id = 293
// module chunks = 0